module.exports = __webpack_public_path__ + "img/d200812-2.1dc24eae.jpg";